import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {
  InvestDetailOperationTotals,
  InvestmentDetailsOperation,
  ReportIncentiveAgentResponseDTO,
  ReqIncentiveDetailsDTOInfo,
  ReqIncentiveDetailsDTOResponse,
} from '@app/control-panel/models/control-panel.model';

import { TranslateService } from '@ngx-translate/core';
import { TransformNumberPipe } from '@app/@shared/pipes/transform-number.pipe';
import {
  AMOUNT_PAID,
  AMOUNT_COLLECTED,
  COMI_VENTAS,
  COMI_SEGURO_VIDA,
  COMI_SEGURO_PAGO,
  PENALTY_YES,
  PENALTY_NO,
  RAPPEL,
  RAPPEL_SIGLAS,
} from '@app/control-panel/penalty-detail/penalty-detail.constants';

@Component({
  selector: 'scf-penalty-detail-table',
  templateUrl: './penalty-detail-table.component.html',
  styleUrls: ['./penalty-detail-table.component.scss'],
})
export class PenaltyDetailTableComponent implements OnInit {
  @Input() data: ReqIncentiveDetailsDTOResponse;
  @Output() nextPage = new EventEmitter<number>();
  @Input() currentPage: number;
  @Input() totalPages: number;

  page: number = 0;

  displayedColumns: string[] = [
    'codBeneficiary',
    'beneficiary',
    'contractId',
    'holderName',
    'productDesc',
    'autDate',
    'amountPenalty',
    'reason',
  ];

  dataSource = new MatTableDataSource<ReqIncentiveDetailsDTOInfo>();
  totals: InvestDetailOperationTotals;

  constructor(
    private cdref: ChangeDetectorRef,
    private translateService: TranslateService,
    private transformNumberPipe: TransformNumberPipe
  ) {}

  ngOnInit(): void {
    this.dataSource.data = this.data.results;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.dataSource.data = this.data.results;
    }
  }

  changePage(page: number) {
    this.nextPage.emit(page);
  }

  getReason(sign: string, description: string, penalty: string): string {
    let reasonType;
    let reason;

    if (sign === AMOUNT_PAID) {
      reasonType = this.translateService.instant('penalty.excel.payment');
    } else if (sign === AMOUNT_COLLECTED) {
      reasonType = this.translateService.instant('penalty.excel.cashing');
      if (penalty === PENALTY_YES) {
        reasonType = reasonType + ' ' + this.translateService.instant('penalty.excel.cancel');
      }
      if (penalty === PENALTY_NO) {
        reasonType = reasonType + ' ' + this.translateService.instant('penalty.excel.return');
      }
    }

    if (description === COMI_VENTAS) {
      reason = reasonType + ' ' + this.translateService.instant('penalty.excel.sales');
    } else if (description === COMI_SEGURO_VIDA) {
      reason = reasonType + ' ' + this.translateService.instant('penalty.excel.sure.life');
    } else if (description === COMI_SEGURO_PAGO) {
      reason = reasonType + ' ' + this.translateService.instant('penalty.excel.sure.payment');
    } else if (description === RAPPEL_SIGLAS) {
      reason = reasonType + ' ' + RAPPEL;
    } else {
      reason = '';
    }

    return reason;
  }

  getIncentive(incentive: any): string {
    if (incentive !== 0) {
      incentive = this.transformNumberPipe.transform(incentive);
    }
    return incentive;
  }
}
